async function hasWebp() {
  return new Promise((res) => {
    const webP = new Image();
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    const cb = () => {
      res(webP.height === 2);
    };
    webP.onload = cb;
    webP.onerror = cb;
  });
}

export default hasWebp;
